import { render } from "./AiFullFillMentText.vue?vue&type=template&id=6ff977ca"
import script from "./AiFullFillMentText.vue?vue&type=script&lang=js"
export * from "./AiFullFillMentText.vue?vue&type=script&lang=js"

import "./AiFullFillMentText.vue?vue&type=style&index=0&id=6ff977ca&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiFullFillMentText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ff977ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ff977ca', __exports__)) {
    api.reload('6ff977ca', __exports__)
  }
  
  module.hot.accept("./AiFullFillMentText.vue?vue&type=template&id=6ff977ca", () => {
    api.rerender('6ff977ca', render)
  })

}


export default __exports__